import { format, differenceInHours } from 'date-fns';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from 'src/components/ui/tooltip';

export const TimestampCellRenderer = ({ value }: { value: number }) => {
  if (!value) return null;

  const date = new Date(value * 1000);
  const now = new Date();
  const hours = differenceInHours(now, date);

  const timeText =
    hours < 24 ? `${hours} hours ago` : `${Math.floor(hours / 24)} days ago`;

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger>
          <span>{timeText}</span>
        </TooltipTrigger>
        <TooltipContent>
          <p>{format(date, 'yyyy-MM-dd HH:mm:ss')}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
